<!-- 示波图组件 -->
<template>
  <div class="signal-group">
    <div @dragover="allowSignalMeasureDrop"
         @drop="(event) => dragToSignalCmp(event, signalItem, itemIndex)"
         class="signal-line-container">
      <div class="line-charts">
        <div class="title">{{ signalData.name }}</div>
        <div class="line-chart-box">
          <div :key="key" @click="clearDefault" style="width: 100%"
               v-for="(chartDataItem,key) in signalData.dataSources">
            <signal-line-chart-component
              :displayStatus="signalItem.signalSourceCheckedArr"
              :echart-key="signalItem.cid + '-'+ key"
              :index="key"
              :topic="topic"
              :signalKeyText="signalItem.signalSourceArr"
              :signal-data="signalData.chartData[key]"
              v-if="!loading"/>
          </div>
        </div>
      </div>
      <div class="signal-source">
        <div class="cmp-handle">
          <el-dropdown>
                        <span class="el-dropdown-link">
                            <i class="el-input__icon el-icon-more"></i>
                        </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-select @change="loadStyle" placeholder="选择主题" style="width: 120px" v-model="topic">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in options">
                  </el-option>
                </el-select>
              </el-dropdown-item>
              <el-dropdown-item :disabled="startStatus.hasStart === true"
                                @click.native="handleCmp('delete', signalData, itemIndex)" divided>删除
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="title">信号源</div>
        <signal-source-checkbox :componentIndex="itemIndex"
                                :detailIndex="index"
                                :key="index"
                                :signalKey="item.key||''"
                                :signalText="item.text"
                                v-for="(item, index) in signalData.dataSources">
        </signal-source-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import SignalLineChartComponent from '@/components/common/echarts/SignalLineChartComponent';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { PROJECT_NODE_TYPE } from '@/common/enums';
// import LineChart from '@/components/common/echarts/LineChart';
import SignalSourceCheckbox from './SignalSourceCheckbox';


export default {
  name: 'signal-line-chart',
  data() {
    return {
      resizekey: 0,
      signalData: {},
      type: 1, // 默认为信号节点
      topic: 'default',
      loading: false,
      options: [{
        value: 'default',
        label: '默认主题',
      }, {
        value: 'vintage',
        label: '复古',
      }, {
        value: 'dark',
        label: '深色',
      }, {
        value: 'macarons',
        label: '马卡龙',
      }, {
        value: 'shine',
        label: '闪耀',
      }, {
        value: 'roma',
        label: '罗马',
      }],
    };
  },
  props: {
    // 当前组件在总的组件数据中的key
    itemIndex: {
      type: Number,
    },
    // 当前组件需要的数据
    signalItem: {
      type: Object,
    },
    startStatus: {
      type: Object,
      default() {
        return true;
      },
    },
  },
  watch: {
    signalItem: {
      handler(newItem) {
        this.signalData = newItem;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState('Engineering', ['checkedChanged', 'componentStyleInfoArray', 'dragTreeNodeType']),
    ...mapGetters('Engineering', ['activedPanelData', 'activedCmpInPanel', 'canSignalArr', 'getCurCmpStatus']),
  },
  components: {
    'signal-source-checkbox': SignalSourceCheckbox,
    'signal-line-chart-component': SignalLineChartComponent,
  },
  methods: {
    ...mapMutations('Engineering', ['clickComponent', 'addSignalToOscr', 'deleteComponent']),
    ...mapActions('Engineering', ['deleteCpt']),
    clearDefault(e) {
      return false;
    },
    // 拖拽进入
    signalDrop(e) {
      console.log(e);
    },
    clickChartCmp(signalIndex) {
      this.clickComponent({ componentName: 'signalCmp', cmpIndex: signalIndex, cmpType: 'signalCmp' });
    },
    // region 示波器
    dragToSignalCmp(event, item, componentIndex) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      const dragNode = JSON.parse(event.dataTransfer.getData('dragNodeData'));
      console.log('示波器组件接受，准备添加', dragNode);
      this.addSignalToOscr({ dragNode, componentIndex, type: this.type });
    },
    allowSignalMeasureDrop(event) {
      event.preventDefault();
      if (this.dragTreeNodeType === PROJECT_NODE_TYPE.DBC_SIGNAL) {
        event.dataTransfer.dropEffect = 'copy';
      } else if (this.dragTreeNodeType === PROJECT_NODE_TYPE.A2L_MEASURE) {
        event.dataTransfer.dropEffect = 'copy';
        this.type = 3;
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
    },
    handleCmp(command, component, index) {
      if (this.getCurCmpStatus) {
        this.$message({
          message: '当前面板正在运行，请先进行关闭',
        });
        return;
      }
      switch (command) {
        case 'delete':
          this.deleteCpt({ index });
          // this.$emit('save-cpm');
          break;
        default:
          break;
      }
    },
    loadStyle() {
      this.loading = true;
      setTimeout(() => this.loading = false, 50);
    },
  },
};
</script>

<style lang="scss">
  .signal-line-container {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    flex-wrap: nowrap;

    &:hover {
      animation: 1s shadowChange infinite;
    }

    @keyframes shadowChange {
      0% {
        box-shadow: 0 0 2px #eee;
      }
      50% {
        box-shadow: 0 0 2px #aaa;
      }
      100% {
        box-shadow: 0 0 2px #eee;
      }
    }

    .line-charts {
      flex: 3;
      border: dashed 1px #eee;
      position: relative;
      overflow: auto;

      .title {
        margin: 15px 0 15px 15px;
        font-size: 14px;
        font-weight: bold;
        height: 30px;
      }

      .line-chart-box {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow-y: auto;
      }
    }

    .signal-source {
      flex: 1;
      border: dashed 1px #eee;
      border-left: none;
      width: 200px;
      display: flex;
      flex-direction: column;
      padding: 15px 10px;

      .title {
        text-align: center;
        font-size: 14px;
        font-weight: bold;
      }

      .cmp-handle {
        position: absolute;
        top: 0;
        right: 0;

        .el-input__icon {
          line-height: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/engineering/SignalLineChart.vue